/* eslint-disable @angular-eslint/prefer-inject */
import { WarehouseDataService } from '../infrastructure/warehouses/warehouse.data.service';
import {
    WarehouseCreate,
    WarehouseDto,
    WarehouseRead,
    WarehouseSearchParams,
} from '../entities/warehouse.dto';
import { WarehouseStore } from '../infrastructure/warehouses/warehouse.store';
import { Injectable } from '@angular/core';
import { RoutesForWarehouse } from './warehouse.routes';
import { AbstractManageEntityFacade } from '@pf/shared-services';
import { WarehouseMapper } from '../infrastructure/warehouses/warehouse.mapper';
import { BuildChangeTrackingFacadeFactory } from '@pf/shared/util-platform';
import { of } from 'rxjs';
import { IQueryParams, QueryFilters, SafeAny } from '@pf/shared-common';
import { IWarehouseEntity } from '../interfaces/warehouse-entity';
import { ResourceAuth } from '@control-tower/platform-wms';

@Injectable()
export class WarehouseFacade extends AbstractManageEntityFacade<
    WarehouseDto,
    WarehouseRead,
    WarehouseCreate,
    WarehouseSearchParams
> {
    nameField: keyof WarehouseDto = 'name';

    constructor(
        dataService: WarehouseDataService,
        routes: RoutesForWarehouse,
        store: WarehouseStore,
        mapper: WarehouseMapper
    ) {
        super(dataService, routes, store, mapper);
    }

    addDefaultWarehouseParam<TWarehouseEntity extends IWarehouseEntity>(
        params: IQueryParams<TWarehouseEntity>
    ) {
        if (!this.active) {
            return of(params);
        }

        params.filters = {
            ...(params.filters || ({} as QueryFilters<TWarehouseEntity>)),
            warehouse: this.active.id,
        } as SafeAny;
        return of(params);
    }

    override applyResourceAuth(body: WarehouseCreate, dto: WarehouseDto): void {
        const locationId =
            dto.location?.id ??
            dto.locationId ??
            (body as { locationId?: string }).locationId;
        body.resourceAuth = {
            locations: locationId ? [locationId] : [],
        } as ResourceAuth;
    }

    manageStructure(id: string) {
        (this.routes as RoutesForWarehouse).structure(id).navigate();
    }

    changeTrackingFactory = BuildChangeTrackingFacadeFactory(
        this.dataService,
        this.nameField
    );

    textSearchFilter(
        searchText: string
    ): Partial<Record<keyof WarehouseDto, string>> {
        return { name: searchText };
    }
}
